import LongitudinalGraph from "./components/LongitudinalGraph";

export default LongitudinalGraph